import InvitationDetail from "./InvitationDetail";
export default InvitationDetail;
